import { render, staticRenderFns } from "./recommend-index.vue?vue&type=template&id=20a97f72&scoped=true&"
import script from "./recommend-index.vue?vue&type=script&lang=js&"
export * from "./recommend-index.vue?vue&type=script&lang=js&"
import style0 from "./recommend-index.vue?vue&type=style&index=0&id=20a97f72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a97f72",
  null
  
)

export default component.exports